import CompetenceSelectionDialog from './CompetenceSelectionDialog';
export default CompetenceSelectionDialog;